import * as React from "react";
import { cn } from "src/utils/ui/ui";

export interface TextAreaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ className, value, onChange, placeholder, ...props }, ref) => {
    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      if (onChange) {
        onChange(e);
      }
      autoResize();
    };

    const autoResize = React.useCallback(() => {
      if (ref && "current" in ref && ref.current) {
        ref.current.style.height = "auto";
        ref.current.style.height = `${ref.current.scrollHeight}px`;
      }
    }, [ref]);

    React.useEffect(() => {
      autoResize();
    }, [autoResize, value]);

    return (
      <textarea
        ref={ref}
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        className={cn(
          "min-h-[100px] w-full resize-none overflow-hidden rounded-md border border-input p-2.5 py-2 text-sm shadow-sm outline-none transition-all placeholder:text-gray-300 focus:border-primary focus:outline-none focus:ring-[0.5px] focus:ring-primary",
          className
        )}
        {...props}
      />
    );
  }
);
TextArea.displayName = "Text Area";

export { TextArea };
